interface UsarRegex {
  compararStringsComCoringa(stringParaComparar: string, string: string): boolean
}

export const usarRegex = (): UsarRegex => {
  const compararStringsComCoringa = (stringParaComparar: string, string: string): boolean => {
    const expressaoModificada = stringParaComparar.replace('**', '.*')
    const expressaoRegular = new RegExp(`^${expressaoModificada}$`)
    return expressaoRegular.test(string)
  }

  return { compararStringsComCoringa }
}
